export default "__VITE_PUBLIC_ASSET__408eb215__"